// extracted by mini-css-extract-plugin
module.exports = {"linkList":"link-list_linkList__13Kx7","titleContainer":"link-list_titleContainer__1vmu5","linkItems":"link-list_linkItems__2MFaW"};